import type { LucideIcon } from "lucide-react";
import type { FC } from "react";
import { ListRow } from "web_myplann/Shared/Components/ListRow";

type Props = {
	onClick: () => void;
	Icon: LucideIcon;
	iconBg: string;
	iconColor: string;
	label: string;
	description?: string;
	hasDivider?: boolean;
};

export const SolutionItemActionRow: FC<Props> = ({
	onClick,
	Icon,
	iconBg,
	iconColor,
	label,
	description,
	hasDivider,
}) => (
	<ListRow
		onClick={onClick}
		icon={<Icon size={16} color={iconColor} />}
		iconBg={iconBg}
		title={label}
		subtitle={description}
		tabularSubtitle
		showChevron={false}
		isLast={!hasDivider}
	/>
);
